import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Typography, Avatar, Box, Button } from "@mui/material";
import { Hail, Key, Cached, Storage, Download } from "@mui/icons-material";
import { modal } from "../../features/modal/modalSlice";
import { createBackUp } from "../../features/download/downloadSlice";
import ResetPassword from "./ResetPassword";
import { LoadingButton } from "@mui/lab";

const Profile = () => {
    const { type, profile } = useSelector(state => state.auth)
    const { isSending } = useSelector(state => state.progress);
    const dispatch = useDispatch();
    return(
        <Container component={Paper} elevation={3} sx={{ p: '2em', mb: '2em' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }} >
                <Avatar sx={{ bgcolor: 'success.main' }}> <Hail /> </Avatar>
            </Box>  
            <Typography variant="h4" align="center" gutterBottom>BIENVENIDO</Typography>
            { type === 'root' 
            ? 
                <Typography variant="h5" align="center" color={'primary.main'} gutterBottom >
                    😎 Administrador 🤙
                    <br /> <br />
                    <LoadingButton
                        startIcon={<Download />}
                        endIcon={<Storage />}
                        loading={isSending}
                        color="success"
                        variant="outlined"
                        onClick={() => createBackUp(dispatch)}
                    >
                        Respaldar Base de Datos
                    </LoadingButton>
                </Typography> 
            : (
                <>
                    <Typography variant="h5" color={'primary.main'} align="center" gutterBottom>{profile.nombre}</Typography>
                    <Typography variant="h6" align="center" gutterBottom>{profile.area}</Typography>
                    <Typography variant="h6" align="center" gutterBottom>{profile?.dependencia}</Typography>
                </>
            ) }
            <Button startIcon={<Cached />} endIcon={<Key />} color="secondary" variant="contained" onClick={() => dispatch(modal())}>Cambiar contraseña</Button>
            <ResetPassword />
        </Container>
    )
}

export default Profile;